import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TradePairFacade, TradePairState } from '../store/bottradepair';

@Injectable({
    providedIn: 'root'
})
export class adminBotDownSideService {
    constructor(
        private http: HttpClient,
        private tradePairFacade: TradePairFacade
    ) { }


    getPairList() {
        return this.http.get(environment.hanumanbotApiUrl + 'api/bot/tradePair')
    }
    getBotCount(params: any) {
        return this.http.get(environment.hanumanbotApiUrl + 'api/bot/getBotCount', { params })
    }
    botValidation(payload: any) {
        return this.http.post(environment.hanumanbotApiUrl + 'api/bot/bot-validation', payload)
    }
    getBotHistory(payload: any) {
        return this.http.post(environment.hanumanbotApiUrl + 'api/bot/getBotHistory', payload)
    }
    getBotProfit() {
        return this.http.get(environment.hanumanbotApiUrl + 'api/bot/getBotPofit')
    }
    getActiveBotByPair(params: any) {
        return this.http.get(environment.hanumanbotApiUrl + 'api/bot/getBotPofit', { params })
    }
    getPositionHistory(payload: any) {
        return this.http.post(environment.hanumanbotApiUrl + 'api/bot/getPositionDetials', payload)
    }
    getOpenOrders(payload: any) {
        return this.http.post(environment.hanumanbotApiUrl + 'api/bot/getOpenOrders', payload)
    }
    getOrderHistory(payload: any) {
        return this.http.post(environment.hanumanbotApiUrl + 'api/bot/getOrderHistory', payload)
    }
    closeBot(payload: any) {
        return this.http.post(environment.hanumanbotApiUrl + 'api/bot/close-bot', payload)
    }
    pauseBot(payload: any) {
        return this.http.post(environment.hanumanbotApiUrl + 'api/bot/pause-bot', payload)
    }
    cancelAndWait(payload: any) {
        return this.http.post(environment.hanumanbotApiUrl + 'api/bot/cancel-limit-and-wait', payload)
    }
    getOpenOChart(payload: any) {
        return this.http.post(environment.hanumanbotApiUrl + 'api/bot/getOpenOrdersChart', payload)
    }
    orderPlace(payload: any) {
        return this.http.post(environment.hanumanbotApiUrl + 'api/bot/orderplace', payload)
    }
    download(payload: any) {
        return this.http.post(environment.hanumanbotApiUrl + `api/bot/download-cvs`, payload, {
            responseType: 'blob', observe: 'events',
            reportProgress: true
        })
    }
    downloadOpportunity(payload: any) {
        return this.http.post(environment.hanumanbotApiUrl + `api/bot/download-opportunity`, payload, {
            responseType: 'blob', observe: 'events',
            reportProgress: true
        })
    }
    blockBot() {
        return this.http.get(environment.hanumanbotApiUrl + 'api/bot/get-last-order')
    }
    getRecentTrade(params: any) {
        return this.http.get(environment.hanumanbotApiUrl + `api/bot/recentTrade/${params}`)
    }
    getOpportunityHistory(payload: any) {
        return this.http.post(environment.hanumanbotApiUrl + 'api/bot/get-opportunity', payload)
    }

    setTradePair({
        firstCurrencySymbol,
        firstCurrencyId,
        firstFloatDigit,
        secondCurrencySymbol,
        secondCurrencyId,
        secondFloatDigit,
        botstatus,
        tikerRoot,
        _id,
        maker_rebate,
        taker_fees
    }: TradePairState) {
        this.tradePairFacade.setTradePair(
            {
                firstCurrencySymbol,
                firstCurrencyId,
                firstFloatDigit,
                secondCurrencySymbol,
                secondCurrencyId,
                secondFloatDigit,
                botstatus,
                tikerRoot,
                _id,
                maker_rebate,
                taker_fees
            })
    }



}
